import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { EntityEspeciesCertificables } from "../../../../actividades/entity-especies-certificables/entity-especies-certificables.model";
import { EntityAcreditacionEmpresa } from "../../../acreditacion-empresa/entity-acreditacion-empresa.model";
import { EntityEtapasEmpresa } from "../../../entity-etapas-empresa/entity-etapas-empresa.model";
import { DetailCardComponentData } from '../datos-mi-empresa-container/datos-mi-empresa-container.component';
import { AcreditacionEmpresaInput } from './acreditacion-empresa.interfaces';
import { Router } from '@angular/router';

@Component({
  selector: 'rpe-acreditacion-empresa',
  templateUrl: './acreditacion-empresa.component.html',
  styleUrls: ['./acreditacion-empresa.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AcreditacionEmpresaComponent {
  @Input() set acreditacionEmpresaInput(data: AcreditacionEmpresaInput) {
    if (data) {
      this.acreditacionEmpresa = data.acreditacionEmpresa
      this.especiesCertificables = data.especiesCertificables
      this.etapasEmpresa = data.etapasEmpresa
    }

    this.acreditacionesPayload = this.setAcreditacionesPayload()
  }

  acreditacionEmpresa: EntityAcreditacionEmpresa[]
  especiesCertificables: EntityEspeciesCertificables[]
  etapasEmpresa: EntityEtapasEmpresa[]

  acreditacionesPayload: DetailCardComponentData[][] = []

  constructor(
    private router: Router,
  ) { }

  setAcreditacionesPayload(): DetailCardComponentData[][] {
    let data: DetailCardComponentData[][] = []

    const acreditacionesEmpresa = this.acreditacionEmpresa

    if (!acreditacionesEmpresa.length) {
      return data
    }

    data = acreditacionesEmpresa.map((acreditacion) => {
      return this.createAcreditacionPayload(acreditacion)
    })

    return data
  }

  createAcreditacionPayload(acreditacion: EntityAcreditacionEmpresa): DetailCardComponentData[] {
    const acreditacionesEtapas = acreditacion.etapas_id.map((etapa) => this.getEtapaEmpresaName(etapa)).join(', ')
    const acreditacionesEspecies = acreditacion.especies_certificable_id.map((especie) => this.getEspecieCertificableName(especie)).join(', ')

    return [{
      label: '',
      value: '',
      children: [
        {
          label: 'Estado',
          value: String(acreditacion.estado_acreditacion_id)
        },
        {
          label: 'Etapas empresa',
          value: acreditacionesEtapas,
        },
        {
          label: 'Especies certificables',
          value: acreditacionesEspecies,
        }
      ]
    }]
  }

  getEspecieCertificableName(id: number): string {
    const especie = this.especiesCertificables.find((especie) => especie.id === id)
    return especie?.nombre_comun + " | " + especie?.nombre_cientifico
  }

  getEtapaEmpresaName(id: number): string {
    const etapa = this.etapasEmpresa.find((etapa) => etapa.id === id)?.nombre
    return etapa
  }

  onEdit(id: number): void {
    this.router.navigateByUrl(`/tramite/acreditacion-empresa/${id}`)
  }
}
